import React from 'react';
import { Image as SemanticImage } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const iconPath = `${process.env.PUBLIC_URL}/assets/img`;

export const Image = ({
  name = '',
  className = '',
  alt = '',
  size = null,
  ...extraProps
}) => (
  <SemanticImage
    src={`${iconPath}/${name}`}
    alt={alt}
    className={className}
    size={size}
    {...extraProps}
  />
);

Image.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  extraProps: PropTypes.node,
  size: PropTypes.oneOf([
    'mini',
    'tiny',
    'small',
    'medium',
    'large',
    'big',
    'huge',
    'massive',
  ]),
};
